import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { ivideonDealerFilterFields } from "~/widgets/Filter/IvideonDealerFilter/model/fields";

export const IvideonDealerFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => ivideonDealerFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow rows={2} />;
};
